module.exports = __webpack_public_path__ + "img/chevron-down-black.1892bdc8.svg";